import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'

export const OpenButton = ({ setOpenResolutionId, setIsChanged, ...props }) => {
  const { record, ag } = props
  const refresh = () => {
    setIsChanged((prev) => {
      let newVal = new Date().getTime()
      return newVal
    })
  }
  const notify = useNotify()

  const open = async (childProps) => {
    const result = await Api.ags3.update(ag.id, {
      open_resolution_id: record.id,
      editing_open_resolution_id: true,
    })
    const { data } = result
    if (result.status === 200) {
      if (setOpenResolutionId) {
        setOpenResolutionId(record.id)
        refresh()
      } else {
        refresh()
      }
      notify('Résolution ouverte')
    } else if (data.message === 2) {
      if (
        window.confirm(
          "Des copropriétaires enregistrés n'ont pas voté. Voulez-vous ouvrir une nouvelle résolution au vote malgré tout?"
        )
      ) {
        const result2 = await Api.ags3.update(ag.id, {
          open_resolution_id: record.id,
          editing_open_resolution_id: true,
          force: true,
        })
        if (result2.status === 200) {
          if (setOpenResolutionId) {
            setOpenResolutionId(record.id)
            refresh()
          } else refresh()
          notify('Résolution ouverte')
        } else {
          notify(`${result2.data.message}`, 'warning')
        }
      }
    } else {
      notify(`${data.message}`, 'warning')
    }
  }
  if (record.majorite_bo == 'sans vote' || record.opened) return null
  return (
    <Button label="Ouvrir au vote" onClick={open} disabled={props.disabled} />
  )
}

export default OpenButton
